// Route standalone model-authored documents through the existing sandboxed
// HTML code-block preview. Never inject their styles/scripts into the chat DOM.
export function normalizeStandaloneHtml(content, { isStreaming = false } = {}) {
  if (typeof content !== 'string'
    || !/^\uFEFF?\s*(?:<!doctype\s+html\b[^>]*>|<html(?:\s|>))/i.test(content)
    || (!isStreaming && !/<\/html>\s*$/i.test(content))) return content;

  // A game can contain Markdown fences in a string/template. Its source must
  // stay in one code block without an embedded fence terminating it early.
  const length = (content.match(/`{3,}/g) || []).reduce((max, run) => Math.max(max, run.length), 2) + 1;
  const fence = '`'.repeat(length);
  return `${fence}html\n${content}\n${fence}`;
}
